export class City {
    constructor(element) {
        this.input = $(element);
        this.target = $(this.input.data('target'));
        this.lastVal = '';

        this.input.on('keyup', () => {
            this.lastVal = this.input.val();
            var self = this;
            setTimeout(function () {
                self.changeInput()
            }, 200);
        });

    }
    changeInput() {
        if (this.input.val() == this.lastVal) {
            this.input.autocomplete({
                source: '/ajax/location/search_city/',
                minLength: 2,
                select: (event, ui) => this.onSelect.call(this, event, ui),
            });
        }
    }
    onSelect(event, ui) {
        let selected = ui.item;

        this.input.val(selected.label);

        if (this.target && this.target.length > 0) {
            this.target.val(selected.value);

            this.target.trigger('mario.city.changed');
        }

        this.input.trigger('mario.city.changed');

        return false;
    }
}